import { CANAL_APP, URL_EMBEDDED_SOAT } from "@/consts/embbed";
import useEmbeddedNavigation from "@/features/Landing/step-initial/hooks/useEmbeddedNavigation";
import { decodeB64 } from "@/utils/decode";
import { getParameterEmbeddedValue } from "@/utils/helpers";
import { useState, useEffect } from "react";

export const useEmbedded = () => {
  const [tipoDocumentoApp, setTipoDocumento] = useState("");
  const [nroDocumentoApp, setNroDocumento] = useState("");
  const [celularApp, setCelularApp] = useState("");
  const [canalApp, setCanalApp] = useState("");
  const [isEmbedded, setIsEmbedded] = useState(false);
  const { urlEmbedded } = useEmbeddedNavigation();

  useEffect(() => {
    if (!urlEmbedded) return;
    const tipoDocumento = decodeB64(
      getParameterEmbeddedValue("tipoDocumento", urlEmbedded)
    );
    const nroDocumento = decodeB64(
      getParameterEmbeddedValue("nroDocumento", urlEmbedded)
    );
    const celular = decodeB64(
      getParameterEmbeddedValue("celular", urlEmbedded)
    );
    const canal = decodeB64(getParameterEmbeddedValue("canal", urlEmbedded));
    const isEmbedded =
      tipoDocumento && nroDocumento && canal && canal === CANAL_APP;
    if (isEmbedded) {
      setTipoDocumento(tipoDocumento);
      setNroDocumento(nroDocumento);
      setCelularApp(celular);
      setCanalApp(canal);
      setIsEmbedded(true);
    } else {
      localStorage.removeItem(URL_EMBEDDED_SOAT);
    }
  }, []);

  return {
    isEmbedded,
    tipoDocumentoApp,
    nroDocumentoApp,
    celularApp,
    canalApp,
  };
};
